import { useDispatch, useSelector } from 'react-redux';

import { selectIsDraftTermsUpdated } from '@lib/tools/locale/selectors/devtoolsLocale';
import { setIsDraftTermsUpdated } from '@lib/tools/locale/slice/devtoolsLocale';

export const useDevtoolsLocale = () => {
  const dispatch = useDispatch();

  const detectIsDraftTermsUpdated = (value: boolean) => {
    dispatch(setIsDraftTermsUpdated(value));
  };

  const isDraftTermsUpdated = useSelector(selectIsDraftTermsUpdated);

  return { detectIsDraftTermsUpdated, isDraftTermsUpdated };
};
